/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.userssearch.rpc.AppUsersSearch
 */

export const searchRpc = {
  serviceName: 'com.hubspot.userssearch.rpc.AppUsersSearch',
  rpcName: 'search',
  auth: 'app',
  fingerprint: 'USJn6TILxEIjXgNYzFPICR769JFskdG8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};